<template>
  <div class="d-inline sort-by-select">
    <span class="plp-sort-header">Sort by: </span>
    <select class="form-select d-inline" v-model="apiStatus.sortBy" @change="applySort($event)">
      <option v-for="option in options" :value="option.value" :key="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  props: {
    apiStatus: {
      type: Object,
      default: {}
    }
  },
  emits: ['applySort', 'queryResults', 'apiStatus', 'trackAction'],
  setup(props, ctx) {
    const apiStatus = props.apiStatus
    const options = ref([
      { text: 'A-Z', value: 'a-z' },
      { text: 'Z-A', value: 'z-a' },
      { text: 'Newest First', value: 'newest-first' },
      { text: 'Oldest First', value: 'oldest-first' }
    ])
    async function applySort(event){
      apiStatus.sortBy = event.target.value
      ctx.emit('queryResults')
      ctx.emit('trackAction', '$click', { text: event.target.text, type: 'sort_option'})
    }
    return {
      applySort,
      options
    }
  },
}
</script>
